import PropTypes from 'prop-types';
import React from 'react';
import CONTENTO_ACCESSIBILITIES from '../../domain/ContentoAccessibilities';
import { getContentUrl } from '../../utils/contentoUtils';
import { createImageProxyUrl } from '../../utils/svtimage';
import PlayImage from '../PlayImage/PlayImage';
import Caption from './components/Caption/Caption';
import LiveBadge from './components/LiveBadge/LiveBadge';
import { CardWrapper, StyledShowcaseCard } from './ShowcaseCard.styles';

export const BADGE_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
};

const ShowcaseCard = ({
    index,
    item,
    onItemClick,
    currentAccessibilityChoiceContento = CONTENTO_ACCESSIBILITIES.DEFAULT,
    big,
    twoColumns,
    badgeSize = BADGE_SIZE.MEDIUM,
    srcSet,
    className,
}) => {
    const imageUrl = createImageProxyUrl(
        item?.images?.wide?.id || item?.images?.id,
        item?.images?.wide?.changed || item?.images?.changed,
        'wide',
        800
    );

    const imageAltText = item?.images?.wide?.description || item?.image?.description || '';

    const url = getContentUrl(item.item, currentAccessibilityChoiceContento);

    return (
        <StyledShowcaseCard
            key={item.item.svtId}
            data-rt="display-window"
            className={className}
            big={big}
            twoColumns={twoColumns}
        >
            <CardWrapper to={url} onAfterClick={(e) => onItemClick(e, index + 1, item.item.svtId)}>
                <LiveBadge live={item.item.live} size={badgeSize} />
                <PlayImage imageRatio="16-9" ssr={true} src={imageUrl} srcSet={srcSet} alt={imageAltText} />
                <Caption
                    byline={item.byline}
                    subHeading={item.subHeading ? item.subHeading : item.description}
                    heading={item.heading}
                />
            </CardWrapper>
        </StyledShowcaseCard>
    );
};

ShowcaseCard.propTypes = {
    index: PropTypes.number,
    item: PropTypes.object.isRequired,
    onItemClick: PropTypes.func,
    currentAccessibilityChoiceContento: PropTypes.oneOf([
        CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED,
        CONTENTO_ACCESSIBILITIES.DEFAULT,
        CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED,
    ]),
    badgeSize: PropTypes.oneOf([BADGE_SIZE.SMALL, BADGE_SIZE.MEDIUM]),
    big: PropTypes.bool,
    twoColumns: PropTypes.bool,
    srcSet: PropTypes.string,
};

export default React.memo(ShowcaseCard);
